import api from './api';

const assetLocationMasterService = {
  // Get all asset locations
  getAllLocations: async (params = {}) => {
    try {
      const response = await api.get('/asset-location-master', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching asset locations:', error);
      throw error;
    }
  },

  // Get asset location by ID
  getLocationById: async (id) => {
    try {
      const response = await api.get(`/asset-location-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error fetching asset location:', error);
      throw error;
    }
  },

  // Create asset location
  createLocation: async (data) => {
    try {
      const response = await api.post('/asset-location-master', data);
      return response.data;
    } catch (error) {
      console.error('Error creating asset location:', error);
      throw error;
    }
  },

  // Update asset location
  updateLocation: async (id, data) => {
    try {
      const response = await api.put(`/asset-location-master/${id}`, data);
      return response.data;
    } catch (error) {
      console.error('Error updating asset location:', error);
      throw error;
    }
  },

  // Delete asset location
  deleteLocation: async (id) => {
    try {
      const response = await api.delete(`/asset-location-master/${id}`);
      return response.data;
    } catch (error) {
      console.error('Error deleting asset location:', error);
      throw error;
    }
  },

  // Get asset location statistics
  getLocationStats: async () => {
    try {
      const response = await api.get('/asset-location-master/stats');
      return response.data;
    } catch (error) {
      console.error('Error fetching asset location statistics:', error);
      throw error;
    }
  },

  // Get next location code
  getNextLocationCode: async () => {
    try {
      const response = await api.get('/asset-location-master/next-code');
      return response.data;
    } catch (error) {
      console.error('Error fetching next location code:', error);
      throw error;
    }
  }
};

export default assetLocationMasterService;
